import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from "@angular/router";

import { ListableListingTimeline, ListingTimelineable } from 'app/models/listing-timeline';
import { DomSanitizer } from '@angular/platform-browser';

import { ListingsService } from 'app/services/listings.service';

import { InlineCarouselOptions } from 'app/models/inline-carousel';
import { User } from 'app/models/user';
import { AirbrakeService } from 'app/services/airbrake.service';
import { HeadService } from 'app/services/head.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'houwzer-listing', // <listing></listing> is a reserved HTML tag name
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss']
})
export class ListingComponent implements OnInit {
  listableListingTimeline: ListableListingTimeline;
  fullScreenCarousel: boolean = false;
  clickedIndex: number;

  inlineCarouselOptions: InlineCarouselOptions = {
    isExpandable: true,
    imageHeight: 250
  }

  timelineId: number;
  primaryAgent: User;
  mailToHref: string;

  associationFee: string;
  isVirtualTourAbsent: boolean;

  youtubeUrl: SafeResourceUrl | null;
  matterportUrl: SafeResourceUrl | null;
  homejab360Url: SafeResourceUrl | null;
  homejabVimeoUrl: SafeResourceUrl | null;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private listingsService: ListingsService,
    private headService: HeadService,
  ) {}

  // Note: ListTrac Tracking code removed 31 August 2023
  ngOnInit() {
    this.headService.setIntitalMetaTagsForPublicListing();
    // TODO: Gracefully handle param not there or param not a number
    this.timelineId = parseInt(this.route.snapshot.params.timeline_id);

    // TODO: Gracefully handle timeline not found
    this.listingsService
      .getListing(this.timelineId)
      .subscribe((listingTimelineable: ListingTimelineable) => {

        this.listableListingTimeline = new ListableListingTimeline(listingTimelineable);
        this.headService.setMetaTagsForPublicListing(this.listableListingTimeline);
        this.headService.setTitle(this.listableListingTimeline.title({ includeCommas: false })).pipe(take(1)).subscribe();
        this.primaryAgent = this.listableListingTimeline.primary_agent;
        this.youtubeUrl = this.sanitizedTimelineFieldValue('youtube-embed-url');
        this.homejab360Url = this.sanitizedTimelineFieldValue('homejab-360-embed-url');
        this.matterportUrl = this.sanitizedTimelineFieldValue('matterport-embed-url');
        this.homejabVimeoUrl = this.sanitizedTimelineFieldValue('homejab-vimeo-url');

        this.associationFee = this.listableListingTimeline.associationFee();
        this.isVirtualTourAbsent = this.noVirtualTours();

      })
  }

  ngOnDestroy() {
    this.headService.setDefaultMetaTags();
  }

  sanitizedTimelineFieldValue(timelineFieldSlug: string) {
    const embedUrl = this.listableListingTimeline.timelineFieldValue(timelineFieldSlug);
    return embedUrl ? this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl) : null;
  }

  openFullScreenCarousel(clickedIndex: number) {
    this.clickedIndex = clickedIndex;
    this.fullScreenCarousel = true;
  }

  listingDescription(){
    let listingDescription = this.listableListingTimeline.timelineFieldValue('approved-listing-description')
    return (listingDescription && listingDescription.length) ? listingDescription : 'Listing Description Coming Soon!';
  }

  noVirtualTours() {
    return [
      !this.sanitizedTimelineFieldValue('youtube-embed-url'),
      !this.sanitizedTimelineFieldValue('homejab-360-embed-url'),
      !this.sanitizedTimelineFieldValue('matterport-embed-url'),
      !this.sanitizedTimelineFieldValue('homejab-vimeo-url'),
    ].every(Boolean)
  }
}
